module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_customer":"Select customer","order_for":"Order for","order_for_hint":"As partner you can select who to order for"},"de":{"select_customer":"Kunde wählen","order_for":"Bestellung für","order_for_hint":"Als Partner können Sie wählen für wen Sie bestellen"}}')
  delete Component.options._Ctor
}
